import { useState } from "preact/hooks";
import { SearchTermsFacet } from "@nosto/nosto-js/client";
import Checkbox from "@/elements/Checkbox/Checkbox";
import { useOptimisticFacet } from "@/hooks/useOptimisticFacet";

type Props = {
  facet: SearchTermsFacet;
};

export default function TermsFacet({ facet }: Props) {
  const MAX_ITEMS = 6;
  const [open, setOpen] = useState<boolean>(true);
  const [showAll, setShowAll] = useState<boolean>(false);
  const { optimisticData, toggleProductFilter } = useOptimisticFacet(facet);
  const visibleItems = showAll
    ? optimisticData
    : optimisticData.slice(0, MAX_ITEMS);
  const hasMore = optimisticData.length > MAX_ITEMS;

  const toggleOpen = () => {
    setOpen((prev) => !prev);
  };
  const toggleShowAll = () => {
    setShowAll((prev) => !prev);
  };

  return (
    <div
      className={`mobile-filter-facets__nav-item ${open ? "mobile-filter-facets__nav-item--is-open" : ""}`}
    >
      <button
        data-nosto-element="facet"
        onClick={toggleOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleOpen();
          }
        }}
        aria-controls={`${facet.id}-sub-menu`}
        aria-expanded={!!open}
        aria-label={`${open ? "Collapse" : "Expand"} ${facet.name}`}
        type="button"
      >
        <span>{facet.name}</span>
        <span
          className="br-icon"
          aria-hidden="true"
          style="--br-icon-width: 16px; --br-icon-height: 16px;"
        >
          <svg>
            {open ? <use href="#minus"></use> : <use href="#plus"></use>}
          </svg>
        </span>
      </button>
      <div
        className="mobile-filter-facets__nav-item-options"
        id={`${facet.id}-sub-menu`}
        role="menu"
      >
        {visibleItems.map((data) => (
          <div key={data.value} role="menuitem">
            <Checkbox
              value={`${data.value} (${data.count})`}
              label={data.value}
              count={data.count}
              selected={data.selected}
              onChange={(e) => {
                e.preventDefault();
                toggleProductFilter(facet.field, data.value, !data.selected);
              }}
              visual={data.visual}
            />
          </div>
        ))}
        {hasMore && (
          <button type="button" onClick={toggleShowAll} aria-expanded={showAll}>
            {showAll ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
  );
}
